import { render, staticRenderFns } from "./partnerReview.vue?vue&type=template&id=e9a588a0&scoped=true&"
import script from "./partnerReview.vue?vue&type=script&lang=js&"
export * from "./partnerReview.vue?vue&type=script&lang=js&"
import style0 from "./partnerReview.vue?vue&type=style&index=0&id=e9a588a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a588a0",
  null
  
)

export default component.exports